export const CARD_NUMBER_PARAM_KEY = 'card_number';
